export const JourneyConstants = {
    JOURNEY_STATE: 'auth.application.detail.growth.journey',
    JOURNEY_FUNNEL_STATE: 'auth.application.detail.growth.journey.funnel',
    JOURNEY_ANALYSIS_STATE: 'auth.application.detail.growth.journey.analysis',
    JOURNEY_CAMPAIGNS_STATE: 'auth.application.detail.growth.journey.campaigns',
    JOURNEY_CAMPAIGN_STATE: 'auth.application.detail.growth.journey.campaign',
};
